<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card card-shadow list-card">
          <div class="container-fluid">
            <div class="row">
              <div class="col text-left">
                <div class="card-body">
                  <h5 class="card-title">Shopping &amp; Pantry Lists</h5>
                  <p class="card-text"></p>
                </div>
              </div>
              <div class="col text-right">
                <div class="card-body">
                  <b-button-group>
                    <b-button variant="outline-primary" @click="showNewList">
                      <i class="fas fa-plus"></i> New List
                    </b-button>
                    <b-dropdown variant="outline-primary" right>
                      <b-dropdown-item @click="showNewShoppingList"
                        >New Shopping List</b-dropdown-item
                      >
                      <b-dropdown-item @click="showNewPantryList"
                        >New Pantry List</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-button-group>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <div class="card-body input-group search-input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search for lists..."
                    v-model="search"
                    @keyup.enter="showSearch"
                  />
                  <div class="input-group-append">
                    <b-button variant="outline-primary" @click="showSearch">
                      <i class="fas fa-search"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="showSearchResults">
              <div class="col text-center">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="mb-3"
                  @click="clearSearchResults"
                >
                  Clear Results <i class="fas fa-times-circle"></i>
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col text-center" v-if="!showSearchResults">
                <b-tabs content-class="mt-3" justified v-model="tabIndex">
                  <b-tab title="Shopping" active>
                    <div
                      v-if="shoppingLists.length === 0"
                      class="text-center mt-4"
                    >
                      <span
                        >Create a new
                        <b-link @click.prevent="showNewShoppingList"
                          >shopping list</b-link
                        ></span
                      >
                    </div>
                    <div v-if="shoppingLists.length > 0">
                      <b-list-group class="mx-2 mb-1">
                        <b-list-group-item
                          v-for="list in shoppingLists"
                          :key="list['.key']"
                          class="text-left"
                        >
                          <span
                            class="item-span cursor-pointer"
                            @click="showList('shopping', list['.key'])"
                          >
                            {{ list.name }}
                          </span>
                          <div class="float-right">
                            <b-button
                              variant="outline-primary"
                              size="sm"
                              class="mr-1"
                              :to="{
                                name: 'list-view',
                                params: { type: 'shopping', id: list['.key'] }
                              }"
                              ><i class="far fa-file-alt"></i> View</b-button
                            >
                            <b-button
                              variant="outline-danger"
                              size="sm"
                              v-b-modal="'modal_list_delete_' + list['.key']"
                            >
                              <i class="far fa-trash-alt"></i>
                            </b-button>

                            <b-modal
                              :id="'modal_list_delete_' + list['.key']"
                              title="Delete List"
                              header-bg-variant="danger"
                              header-text-variant="light"
                              ok-title="Delete"
                              ok-variant="danger"
                              @ok="deleteList('shopping', list['.key'])"
                            >
                              <p>
                                Are you sure you want to delete the list
                                {{ list.name }}?
                              </p>
                            </b-modal>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </div>

                    <b-modal
                      id="modal_lists_create_shopping"
                      title="New Shopping List"
                      header-bg-variant="primary"
                      header-text-variant="light"
                      ok-title="Create"
                      ok-variant="primary"
                      @ok="createShoppingList()"
                    >
                      <b-form-group
                        description="A name for the new shopping list."
                        label="List Name"
                        label-for="shopping-list-name"
                      >
                        <b-form-input
                          id="shopping-list-name"
                          v-model="list.name"
                          trim
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        description="The planned shopping date for the list."
                        label="Shopping Date"
                        label-for="shopping-list-date"
                      >
                        <b-form-datepicker
                          id="shopping-list-date"
                          v-model="list.date"
                        ></b-form-datepicker>
                      </b-form-group>
                    </b-modal>
                  </b-tab>
                  <b-tab title="Pantry">
                    <div
                      v-if="pantryLists.length === 0"
                      class="text-center mt-4"
                    >
                      <span
                        >Create a new
                        <b-link @click.prevent="showNewPantryList"
                          >pantry list</b-link
                        ></span
                      >
                    </div>
                    <div v-if="pantryLists.length > 0">
                      <b-list-group class="mx-2 mb-1">
                        <b-list-group-item
                          v-for="list in pantryLists"
                          :key="list['.key']"
                          class="text-left"
                        >
                          <span
                            class="item-span cursor-pointer"
                            @click="showList('pantry', list['.key'])"
                            >{{ list.name }}
                          </span>
                          <div class="float-right">
                            <b-button
                              variant="outline-primary"
                              size="sm"
                              class="mr-1"
                              :to="{
                                name: 'list-view',
                                params: { type: 'pantry', id: list['.key'] }
                              }"
                              ><i class="far fa-file-alt"></i> View</b-button
                            >
                            <b-button
                              variant="outline-danger"
                              size="sm"
                              v-b-modal="'modal_list_delete_' + list['.key']"
                            >
                              <i class="far fa-trash-alt"></i>
                            </b-button>

                            <b-modal
                              :id="'modal_list_delete_' + list['.key']"
                              title="Delete List"
                              header-bg-variant="danger"
                              header-text-variant="light"
                              ok-title="Delete"
                              ok-variant="danger"
                              @ok="deleteList('pantry', list['.key'])"
                            >
                              <p>
                                Are you sure you want to delete the list
                                {{ list.name }}?
                              </p>
                            </b-modal>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                    </div>

                    <b-modal
                      id="modal_lists_create_pantry"
                      title="New Pantry List"
                      header-bg-variant="primary"
                      header-text-variant="light"
                      ok-title="Create"
                      ok-variant="primary"
                      @ok="createPantryList()"
                    >
                      <b-form-group
                        description="A name for the new pantry list."
                        label="List Name"
                        label-for="pantry-list-name"
                      >
                        <b-form-input
                          id="pantry-list-name"
                          v-model="list.name"
                          trim
                        ></b-form-input>
                      </b-form-group>
                    </b-modal>
                  </b-tab>
                </b-tabs>
              </div>
              <div class="col text-center" v-if="showSearchResults">
                <b-list-group class="mx-2 mb-1">
                  <b-list-group-item
                    v-for="list in searchResults"
                    :key="list['.key']"
                    class="text-left"
                  >
                    <span
                      class="item-span cursor-pointer"
                      @click="showList(list.type, list['.key'])"
                      >{{ list.name }}
                    </span>
                    <small class="mr-2"
                      ><i>{{ list.type }}</i></small
                    >
                    <div class="float-right">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        class="mr-1"
                        :to="{
                          name: 'list-view',
                          params: { type: list.type, id: list['.key'] }
                        }"
                        ><i class="far fa-file-alt"></i> View</b-button
                      >
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        v-b-modal="'modal_list_delete_' + list['.key']"
                      >
                        <i class="far fa-trash-alt"></i>
                      </b-button>

                      <b-modal
                        :id="'modal_list_delete_' + list['.key']"
                        title="Delete List"
                        header-bg-variant="danger"
                        header-text-variant="light"
                        ok-title="Delete"
                        ok-variant="danger"
                        @ok="deleteList(list.type, list['.key'])"
                      >
                        <p>
                          Are you sure you want to delete the list
                          {{ list.name }}?
                        </p>
                      </b-modal>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div class="col text-left">
                <div class="card-body"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FirebaseMixin from "@/mixins/Firebase";
import UtilsMixin from "@/mixins/Utils";
import moment from "moment";

export default {
  name: "Lists",
  mixins: [FirebaseMixin, UtilsMixin],
  components: {},
  data() {
    return {
      ref: "lists",
      bind: [],
      shoppingLists: [],
      pantryLists: [],
      list: {
        name: "",
        date: ""
      },
      tabIndex: 0,
      showSearchResults: false,
      searchResults: [],
      search: ""
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "userProfile"]),
    ...mapGetters(["familyShoppingDay"]),
    familyKey() {
      return this.userProfile.family_key;
    },
    listDate() {
      return moment().day(this.familyShoppingDay) > moment()
        ? moment().day(this.familyShoppingDay)
        : moment()
            .day(this.familyShoppingDay)
            .add(1, "weeks");
    }
  },
  watch: {
    familyKey: {
      immediate: true,
      handler(family_key) {
        console.log(family_key);
        if (family_key !== null) {
          this.bindObject(
            "lists/" + family_key + "/shopping",
            null,
            "shoppingLists"
          );
          this.bindObject(
            "lists/" + family_key + "/pantry",
            null,
            "pantryLists"
          );
        }
      }
    },
    tabIndex: {
      immediate: false,
      handler(tabIndex) {
        console.log(tabIndex);
        switch (tabIndex) {
          case 0:
            history.replaceState({}, null, "/lists/shopping");
            break;
          case 1:
            history.replaceState({}, null, "/lists/pantry");
            break;
          default:
            history.replaceState({}, null, "/lists/shopping");
        }
      }
    }
  },
  methods: {
    showNewShoppingList() {
      this.list.name = "Shopping List " + this.listDate.format("L");
      this.list.date = this.listDate.format("YYYY-MM-DD");
      this.$bvModal.show("modal_lists_create_shopping");
    },
    showNewPantryList() {
      this.list.name = "Pantry List " + moment().format("L");
      this.$bvModal.show("modal_lists_create_pantry");
    },
    showNewList() {
      if (this.tab === 0) {
        this.showNewShoppingList();
      } else {
        this.showNewPantryList();
      }
    },
    createShoppingList() {
      const list = {
        name: this.list.name,
        date: this.list.date,
        items: []
      };
      this.createObject("lists/" + this.familyKey + "/shopping", list)
        .then(result => {
          this.showList("shopping", result.key);
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred creating the list. Please try again later."
          );
        });
    },
    createPantryList() {
      const list = {
        name: this.list.name,
        items: []
      };
      this.createObject("lists/" + this.familyKey + "/pantry", list)
        .then(result => {
          this.showList("pantry", result.key);
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred creating the list. Please try again later."
          );
        });
    },
    setTab(name = null) {
      name = String(name).toLowerCase();
      console.log("Tab: " + name);
      switch (name) {
        case "shopping":
          this.tabIndex = 0;
          break;
        case "pantry":
          this.tabIndex = 1;
          break;
        default:
          this.tabIndex = 0;
      }
    },
    showSearch() {
      this.showSearchResults = true;
      this.searchResults = [];
      this.shoppingLists.forEach(list => {
        if (list.name.toLowerCase().includes(this.search.toLowerCase())) {
          const searchList = {
            type: "Shopping",
            ...list
          };
          this.searchResults.push(searchList);
        }
      });
      this.pantryLists.forEach(list => {
        if (list.name.toLowerCase().includes(this.search.toLowerCase())) {
          const searchList = {
            type: "Pantry",
            ...list
          };
          this.searchResults.push(searchList);
        }
      });
    },
    clearSearchResults() {
      this.showSearchResults = false;
      this.searchResults = [];
      this.search = "";
    },
    showList(type, id) {
      this.navigate("list-view", { type: type, id: id });
    },
    deleteList(type, key) {
      this.deleteObject("lists/" + this.familyKey + "/" + type + "/" + key)
        .then(() => {
          window.toastr.success("List deleted successfully.");
        })
        .catch(error => {
          console.log(error);
          window.toastr.error(
            "An error occurred while updating the list. Please try again later."
          );
        });
    }
  },
  created() {
    this.setTab(this.$route.params.tab);
  }
};
</script>

<style scoped>
.list-card {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
#inpSearch {
  max-width: 500px;
}

.search-input-group {
  margin-left: auto;
  margin-right: auto;
  padding-top: 0;
  max-width: 500px;
}

#btnNewItem {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
}

.item-span {
  width: calc(100% - 31px);
}

.cursor-pointer {
  cursor: pointer;
}
</style>
